import { atom, useSetAtom, useAtomValue } from 'jotai'

/**
 * Active audio note atom management
 * Following the same pattern as chats.ts
 */

// The active audio note atoms
const activeAudioNoteIdAtom = atom<string | undefined>(undefined)

/**
 * Get and set hooks for active audio note ID.
 */
export const useActiveAudioNoteId = () => {
  return useAtomValue(activeAudioNoteIdAtom)
}

export const useSetActiveAudioNote = () => {
  return useSetAtom(activeAudioNoteIdAtom)
}

/**
 * Close active audio note (set to undefined)
 */
const closeActiveAudioNoteAtom = atom(
  null, // it's a convention to pass `null` for the first argument
  (_get, set) => {
    set(activeAudioNoteIdAtom, undefined)
  },
)

export const useCloseActiveAudioNote = () => {
  return useSetAtom(closeActiveAudioNoteAtom)
}
